import React from 'react';
import { Mail, Download } from 'lucide-react';
import SectionHeader from './ui/SectionHeader';
import Button from './ui/Button';

const Skills = () => {
  const skillCategories = [
    {
      code: '01',
      category: 'HSE management',
      skills: [
        'Risk assessment and hazard identification',
        'HIRARC and Job Safety Analysis',
        'Accident investigation',
        'Safety management systems',
        'Permit to work and site inspection',
        'Toolbox talk and HSE induction',
        'Emergency response and PPE control',
        'Lockout/tagout, confined space, hot work, and lifting equipment',
      ],
    },
    {
      code: '02',
      category: 'Standards and compliance',
      skills: [
        'ISO 9001, ISO 14001, ISO 45001',
        'SMK3',
        'UKL-UPL',
        'Contractor Safety Management System (CSMS)',
        'K3 Migas',
        'Authorized Gas Tester (AGT)',
        'First Aider',
        'NEBOSH IGC (certificate not yet issued)',
      ],
    },
    {
      code: '03',
      category: 'Work settings',
      skills: [
        'Onshore drilling',
        'Construction safety',
        'Marine construction',
      ],
    },
  ];

  const certifications = [
    { name: 'First Aider (Petugas P3K)', issuer: 'Kemnaker', status: 'May 2026' },
    { name: 'NEBOSH IGC', issuer: 'NEBOSH', status: 'Not issued' },
    { name: 'Authorized Gas Tester (AGT)', issuer: 'BNSP', status: 'Apr 2026' },
    { name: 'Operator K3 Migas', issuer: 'BNSP', status: 'Dec 2023' },
    { name: 'ISO 9001, 14001, 45001 and SMK3', issuer: 'LSP', status: 'Awareness' },
    { name: 'Instruktur Pelaksana Pelatihan Tatap Muka', issuer: 'BNSP', status: 'Sep 2019' },
    { name: 'OSH Expert (AK3 Umum)', issuer: 'Kemnaker', status: 'Aug 2016' },
  ];

  return (
    <section id="skills" className="section-rule bg-btc-void">
      <div className="container-max section-padding py-24">
        <SectionHeader
          number="07"
          label="Method"
          title="Skills"
        />

        <div className="surface-card overflow-hidden">
          <div className="border-b border-white/10 px-6 py-4">
            <p className="label">Certifications</p>
          </div>
          {certifications.map((cert, index) => (
            <div
              key={cert.name}
              className={`grid grid-cols-12 items-center px-6 py-4 ${
                index !== certifications.length - 1 ? 'border-b border-white/10' : ''
              }`}
            >
              <span className="col-span-2 font-mono text-xs text-btc-orange md:col-span-1">
                {String(index + 1).padStart(2, '0')}
              </span>
              <span className="col-span-10 font-heading font-medium text-white md:col-span-7">
                {cert.name}
              </span>
              <span className="col-span-6 mt-1 font-mono text-xs text-btc-muted md:col-span-2 md:mt-0">
                {cert.issuer}
              </span>
              <span className="col-span-4 mt-1 text-right font-mono text-xs text-btc-gold md:col-span-2 md:mt-0">
                {cert.status || cert.year}
              </span>
            </div>
          ))}
        </div>

        <div className="mt-6 grid gap-4 md:grid-cols-2">
          {skillCategories.map((category) => (
            <div key={category.code} className="surface-card p-8">
              <p className="label">
                {category.code}. {category.category}
              </p>
              <ul className="mt-6 space-y-3">
                {category.skills.map((skill) => (
                  <li key={skill} className="border-b border-white/10 py-3 text-sm text-white last:border-b-0">
                    {skill}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="surface-card mt-12 p-8 shadow-glow md:p-16">
          <p className="label">Contact</p>
          <h3 className="mt-4 max-w-3xl font-heading text-3xl font-bold leading-tight text-white md:text-5xl">
            Available for the next HSE role.
          </h3>
          <p className="mt-6 max-w-xl leading-relaxed text-btc-muted">
            Email wimboro@gmail.com, or call +62 822 3402 7884.
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a href="mailto:wimboro@gmail.com" className="btn-btc-outline w-full sm:w-auto">
              <Mail size={16} strokeWidth={2} />
              Email me
            </a>
            <Button
              href="/documents/CV-Wimboro.pdf"
              download
              className="w-full sm:w-auto"
            >
              <Download size={16} strokeWidth={2} />
              Download CV
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
